// extracted by mini-css-extract-plugin
export default {"fullWidth":"ho-z","image":"io-z","lazyLoadPicture":"jo-z","lazyLoadSpinner":"ko-z","lazyLoadSpin":"lo-z","lazyLoadImage":"mo-z","hasStyledAspectRatio":"no-z"};